import type { FC } from 'react';

import { useTranslation } from '@crehana/i18n';

import * as St from './BreadCrumb.styles';

interface BreadCrumbProps {
  currentStep: number;
}

const BreadCrumb: FC<React.PropsWithChildren<BreadCrumbProps>> = ({
  currentStep,
}) => {
  const { t } = useTranslation();

  return (
    <St.Container>
      {[...Array(3)].map((_, i) => {
        const isActive = currentStep === i + 1;
        return (
          // biome-ignore lint/suspicious/noArrayIndexKey: legacy code - suspicious/noArrayIndexKey
          <div key={`breadcrumb-${i}`} className="flex items-center">
            <St.Circle active={isActive} className="tw-font-subtitle5">
              {i + 1}
            </St.Circle>
            <St.StepName active={isActive} className="font-subtitle4">
              {t(`HEADER_BREADCRUMB_TITLE_${i + 1}`)}
            </St.StepName>
            {i < 2 && <St.Divider className="mr-12" />}
          </div>
        );
      })}
    </St.Container>
  );
};

export default BreadCrumb;
